<!--  BEGIN CONTENT PART  -->
<div id="content" class="main-content">
    <div class="container">

        <div class="page-header">
            <div class="page-title">
                <h1>Notre référentiel</h1>
            </div>
            <div *ngIf="success" class="alert alert-success alert-dismissible fade show row offset-lg-8 col-lg-4" role="alert" style="background-image: linear-gradient(135deg,#30648fed 0,#009de6c4 100%) !important;">
                <strong>{{message}}!</strong> 
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div *ngIf="fail" class="alert alert-danger alert-dismissible fade show row offset-lg-7 col-lg-5" role="alert" style="background-image: linear-gradient(135deg,#8f3030ed 0,#e60000c4 100%) !important;">
                <strong>{{message}}!</strong>
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div *ngIf="loader" class="alert alert-info alert-dismissible fade show row offset-lg-8 col-lg-4 clignote" role="alert">
                <strong>{{message}}</strong> En cours.
                <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-6 layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l">
                        <div id="sectors" class="header">
                            <h2 class="mb-3" style="margin:5px">Secteurs d'activités</h2>
                            <form [formGroup]="sectorForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Saisir le nouveau secteur" aria-label="" formControlName="sector">
                                    <div class="input-group-append">
                                        <button class="btn btn-default addBtn" *ngIf="!update" type="submit" (click)="addSector()" [disabled]="sectorForm.invalid">Ajouter</button>
                                        <button class="btn btn-default addBtn" *ngIf="update" type="button" (click)="submitToUpdateSector()" [disabled]="sectorForm.invalid">Modifier</button>
                                    </div>
                                </div>
                            </form>
                            <form [formGroup]="sectorSearchForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Rechercher un secteur" aria-label="" name="sectorToSearch" formControlName="search">
                            </div>
                        </form>
                        </div>
                        <div *ngIf="sectorsLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <ul id="todo-items-container" *ngIf="!sectorsLoader">
                            <li class="todo-item" *ngFor="let item of sectorsFiltered">
                                <span class="text">{{item.label}}</span>
                                <span class="fa fa-pencil" (click)="updateSector(item)"></span>
                                <span class="close fa fa-times" role="button" data-toggle="modal" data-target="#deleteSectorModal" (click)="getSector(item)" title="supprimer le secteur" aria-label="Delete"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 

            <div class="col-lg-6 layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l">
                        <div id="cities" class="header">
                            <h2 class="mb-3" style="margin:5px">Villes</h2>
                            <form [formGroup]="cityForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Saisir la nouvelle ville" aria-label="" formControlName="city">
                                <div class="input-group-append">
                                    <button class="btn btn-default addBtn" *ngIf="!updateC" type="button" (click)="addCity()" [disabled]="cityForm.invalid">Ajouter</button>
                                    <button class="btn btn-default addBtn" *ngIf="updateC" type="button" (click)="submitToUpdateCity()" [disabled]="cityForm.invalid">Modifier</button>
                                </div>
                            </div>
                            </form>
                            <form [formGroup]="citySearchForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Rechercher une ville" aria-label="" name="cityToSearch" formControlName="search">
                            </div>
                            </form>
                        </div>
                        <div *ngIf="citiesLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <ul id="todo-items-container" *ngIf="!citiesLoader">
                            <li class="todo-item" *ngFor="let item of citiesFiltered">
                                <span class="text">{{item.city}}</span>
                                <span class="fa fa-pencil" (click)="updateCity(item)"></span>
                                <span class="close fa fa-times" role="button" data-toggle="modal" data-target="#deleteCityModal" (click)="getCity(item)" title="supprimer la ville" aria-label="Delete"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 

            <div class="col-lg-6 layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l">
                        <div id="topics" class="header">
                            <h2 class="mb-3" style="margin:5px">Topics</h2>
                            <form [formGroup]="topicForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Saisir le nouveau topic" aria-label="" formControlName="topic">
                                <div class="input-group-append">
                                    <button class="btn btn-default addBtn" *ngIf="!updateT" type="button" (click)="addTopic()" [disabled]="topicForm.invalid">Ajouter</button>
                                    <button class="btn btn-default addBtn" *ngIf="updateT" type="button" (click)="submitToUpdateTopic()" [disabled]="topicForm.invalid">Modifier</button>
                                </div>
                            </div>
                            </form>
                            <form [formGroup]="topicSearchForm">
                            <div class="input-group mb-4">
                                <input type="text" class="form-control" placeholder="Rechercher un topic" aria-label="" name="topicToSearch" formControlName="search">
                            </div>
                            </form>
                        </div>
                        <div *ngIf="topicsLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <ul id="todo-items-container" *ngIf="!topicsLoader">
                            <li class="todo-item" *ngFor="let item of topicsFiltered">
                                <span class="text">{{item.topic}}</span>
                                <span class="fa fa-pencil" (click)="updateTopic(item)"></span>
                                <span class="close fa fa-times" role="button" data-toggle="modal" data-target="#deleteTopicModal" (click)="getTopic(item)" title="supprimer la ville" aria-label="Delete"></span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
            
            <div class="col-lg-6 layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-content widget-content-area modern-todo todo-l">
                        <div id="classes" class="header">
                            <h2 class="mb-3" style="margin:5px">Classes</h2>
                            
                            <form [formGroup]="classSearchForm">
                                <div class="input-group mb-4">
                                    <input type="text" class="form-control" placeholder="Rechercher une classe" aria-label="" name="cityToSearch" formControlName="search">
                                </div>
                            </form>
                        </div>
                        <div *ngIf="classesLoader" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 15%;
                            margin-bottom: 15%;">
                        </div>
                        <ul id="todo-items-container" *ngIf="!classesLoader">
                            <li class="todo-item row font-weight-bold" *ngIf="classesFiltered.length>0">
                                <span class="text col ">Classe</span>
                                <span class="text col">Visite/période</span>
                                <span class="text col">Visite/an</span>
                            </li>
                            <li class="todo-item row" *ngFor="let item of classesFiltered">
                                <span class="text col">{{item.refClass}}</span>
                                <span class="text col">{{item.period}}</span>
                                <span class="text col">{{item.year}}</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div> 
        </div>
    </div>
</div>
<!--  END CONTENT PART  -->

  
<!-- delete sector Modal -->
<div class="modal" tabindex="-1" role="dialog" id="deleteSectorModal" style="z-index: 9999;" *ngIf="sectorToDelete">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
        
            <div class="modal-body">
                <div class="my-3 text-center">
                    <h4> <span> Voulez-vous vraiment supprimer ce secteur: {{sectorToDelete.label}}? </span></h4>
                </div>
            </div>

            <div  class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary rounded-pill" data-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-danger mx-2 rounded-pill"(click)="deleteSector(sectorToDelete.id)" data-dismiss="modal">Supprimer</button>  
            </div>
        
        </div>
    </div>
</div>

<!-- delete sector Modal -->
<div class="modal" tabindex="-1" role="dialog" id="deleteCityModal" style="z-index: 9999;" *ngIf="cityToDelete">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
        
            <div class="modal-body">
                <div class="my-3 text-center">
                    <h4> <span> Voulez-vous vraiment supprimer cette ville: {{cityToDelete.city}}? </span></h4>
                </div>
            </div>

            <div  class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary rounded-pill" data-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-danger mx-2 rounded-pill"(click)="deleteCity(cityToDelete.uuid)" data-dismiss="modal">Supprimer</button>  
            </div>
        
        </div>
    </div>
</div>

<!-- delete Topic Modal -->
<div class="modal" tabindex="-1" role="dialog" id="deleteTopicModal" style="z-index: 9999;" *ngIf="topicToDelete">
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
                </button>
            </div>
        
            <div class="modal-body">
                <div class="my-3 text-center">
                    <h4> <span> Voulez-vous vraiment supprimer ce topic: {{topicToDelete.topic}}? </span></h4>
                </div>
            </div>

            <div  class="modal-footer justify-content-center">
                <button type="button" class="btn btn-secondary rounded-pill" data-dismiss="modal">Annuler</button>
                <button type="button" class="btn btn-danger mx-2 rounded-pill"(click)="deleteTopic(topicToDelete.uuid)" data-dismiss="modal">Supprimer</button>  
            </div>
        
        </div>
    </div>
</div>